import { memo } from 'react';

import { Flex, Tag, Typography } from 'antd';

import './selected-groups.scss';

const { Text } = Typography;

function SelectedGroups({ options, query }) {
  const renderRules = node => {
    if (!node) return null;

    if (Array.isArray(node.rules)) {
      return (
        <Flex align="center" wrap gap="5px 0" className="groups-container">
          {node.rules.map((rule, index) => (
            <Flex align="center" className="group-container" key={rule.id}>
              {renderRules(rule)}
              {index < node.rules.length - 1 && (
                <Text className="group-text" type="secondary" style={{ margin: '0 8px' }}>
                  {node.combinator}
                </Text>
              )}
            </Flex>
          ))}
        </Flex>
      );
    }

    const label = options?.find(option => option.value === node.value)?.label || node.value;
    const color = options?.find(option => option.label === node.value)?.color || '#51ae32';

    return (
      <Tag className="group-tag" color={color}>
        {label}
      </Tag>
    );
  };

  return <>{renderRules(query)}</>;
}

export default memo(SelectedGroups);
